var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9548_2089)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.625 21H27.375C25.6848 21.0018 24.0644 21.6543 22.8693 22.8143C21.6741 23.9743 21.0019 25.547 21 27.1875V47.8125C21.0019 49.453 21.6741 51.0257 22.8693 52.1857C24.0644 53.3457 25.6848 53.9982 27.375 54H48.625C50.3152 53.9982 51.9356 53.3457 53.1307 52.1857C54.3259 51.0257 54.9981 49.453 55 47.8125V27.1875C54.9981 25.547 54.3259 23.9743 53.1307 22.8143C51.9356 21.6543 50.3152 21.0018 48.625 21ZM27.375 25.125H48.625C49.1886 25.125 49.7291 25.3423 50.1276 25.7291C50.5261 26.1159 50.75 26.6405 50.75 27.1875V47.8125C50.7504 48.0834 50.6955 48.3516 50.5885 48.6017C50.4815 48.8519 50.3246 49.079 50.1267 49.27L37.7563 37.2635C36.6937 36.2324 35.2526 35.6532 33.75 35.6532C32.2474 35.6532 30.8063 36.2324 29.7437 37.2635L25.25 41.625V27.1875C25.25 26.6405 25.4739 26.1159 25.8724 25.7291C26.2709 25.3423 26.8114 25.125 27.375 25.125Z",
    fill: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 36C45.2091 36 47 34.2091 47 32C47 29.7909 45.2091 28 43 28C40.7909 28 39 29.7909 39 32C39 34.2091 40.7909 36 43 36Z",
    fill: "#A2A2A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9548_2089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaChat);
export default __webpack_public_path__ + "static/media/media-chat.1780fd2fd8a3d6828008cc272f80c382.svg";
export { ForwardRef as ReactComponent };